import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)
import kids from './kids';

export default new Vuex.Store({
  state: {
    digits: null,
    steps: null,
    speed: null,
    method: null,
    loading : true,

    animationRunning: false,
    displayNumber: 0,
  },
  getters: {
    digits : state => state.digits,
    steps : state => state.steps,
    speed : state => state.speed,
    method : state => state.method,
    loading : state => state.loading,
    displayNumber: state => state.displayNumber,
  },
  mutations: {
    setParams(state,payload){
      state.digits = payload.digits
      state.speed = payload.speed
      state.steps = payload.steps
      state.method = payload.method
      state.loading = false;
    },
    setDisplayNumber(state,payload){
      state.displayNumber = payload
    },
    setAnimationRunning(state,payload){
      state.animationRunning = payload
    }
  },
  actions: {
    setParameters({commit,state}, payload){
      state.loading = true;
      commit('setParams', payload)
    },
    setDisplayNumber({commit}, payload){
      commit('setDisplayNumber', payload)
    },
    setAnimationRunning({commit}, payload){
      commit('setAnimationRunning',payload)
    }
  },
  modules: {
    kids,
  }
})
